import { Vector3 } from 'three';

export default class GlobeState {
  constructor(name, zoomFactor, rotationSpeed, zoomFactorSmoothing) {
    this.name = name;
    this.lat = undefined;
    this.long = undefined;
    this.zoomFactor = zoomFactor || 0;
    this.rotationSpeed = rotationSpeed || 0;
    this.zoomFactorSmoothing = zoomFactorSmoothing || 0;
    this.pivot = new Vector3(0, 0, 0);
    this.pinPhase = 1;
    this.zoomCurve = 1.0;
    this.labelSize = 0.0;
  }

  activate() {}

  deactivate() {}
}
